import { render, staticRenderFns } from "./SelectFields.vue?vue&type=template&id=0b6e18c6"
import script from "./SelectFields.vue?vue&type=script&lang=js"
export * from "./SelectFields.vue?vue&type=script&lang=js"
import style0 from "./SelectFields.vue?vue&type=style&index=0&id=0b6e18c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports